import { IFluidObject } from '@fluidframework/core-interfaces';
import {
  Audience,
  HostContext as MessageTypesHostContext,
  HostUserContext,
  HostLocaleContext,
  PairingValue
} from '../MessageTypes';
import { HostPerformanceData, HostContext as OftHostContext } from '@fluidx/office-fluid-types';

/**
 * Proxy HostContext to be used by the container
 * @param scope An IFluidObject object that will be available to all containers/components loaded
 */
export function getHostSideHostContext(scope: IFluidObject): MessageTypesHostContext | undefined {
  if (scope.HostContext) {
    return {
      audience: scope.HostContext.audience,
      hostCorrelationId: scope.HostContext.hostCorrelationId,
      hostSessionId: scope.HostContext.hostSessionId,
      hostName: scope.HostContext.hostName,
      userContext: scope.HostContext.userContext,
      hostScenarioName: scope.HostContext.hostScenarioName,
      hostAppVersion: scope.HostContext.hostAppVersion,
      hostScenarioStartTime: scope.HostContext.hostScenarioStartTime,
      hostPerformanceData: scope.HostContext.hostPerformanceData,
      hostLocaleContext: scope.HostContext.hostLocaleContext
    } as MessageTypesHostContext;
  }

  return undefined;
}

export function getGuestSideHostContext(
  hostContext: PairingValue<MessageTypesHostContext | undefined>
): OftHostContext {
  // TODO: All our external interfaces enforce HostContext, but our internal types do not. We should mitigate this problem
  if (!hostContext || 'found' in hostContext) {
    throw new Error('HostContext should be serializable and should not be undefined');
  }
  return new IFrameHostContextProxy(hostContext);
}

class IFrameHostContextProxy implements OftHostContext {
  readonly audience: Audience;
  readonly hostCorrelationId: string;
  readonly hostSessionId: string;
  readonly hostName: string;
  readonly userContext: HostUserContext;
  readonly hostScenarioName?: string;
  readonly hostAppVersion?: string;
  readonly hostScenarioStartTime?: number;
  readonly hostPerformanceData?: HostPerformanceData;
  readonly hostLocaleContext?: HostLocaleContext;

  public constructor(hostContext: MessageTypesHostContext) {
    this.audience = hostContext.audience;
    this.hostCorrelationId = hostContext.hostCorrelationId;
    this.hostSessionId = hostContext.hostSessionId || '';
    this.hostName = hostContext.hostName;
    this.userContext = hostContext.userContext;
    this.hostScenarioName = hostContext.hostScenarioName;
    this.hostAppVersion = hostContext.hostAppVersion;
    this.hostScenarioStartTime = hostContext.hostScenarioStartTime;
    this.hostPerformanceData = hostContext.hostPerformanceData;
    this.hostLocaleContext = hostContext.hostLocaleContext;
  }

  public get HostContext() {
    return this;
  }
}
